import LoginContentComponent from './components/login-content';

import './styles/login-container.scss';

export const LoginContent = LoginContentComponent;
